import React from 'react'
import { Text } from '../../../common/Text'
import {
  Container,
  IconsContainer,
  FacebookMaintenace,
  TwitterMaintenace,
  YouTubeMaintenace,
  TruckLogoMaintenace,
  LinkedInMaintenace,
  StyledLink,
  StyledMessage,
  Center,
  StyledFollusUs,
  MaintenanceWrp,
  Maintenance,
  MaintenanceImg,
} from './style'
import { useSelector } from 'react-redux'

export default function MaintenancePageUI() {
  const { organizationData } = useSelector((state) => state.organization)
  const { social = {} } = organizationData?.config || {}
  const {
    facebookHandle = '',
    twitterHandle = '',
    youtubeHandle = '',
    linkedinHandle = '',
  } = social
  const url =
    organizationData?.config?.website?.theme?.externalLinks[0]?.url || ''
  const { countryCode } = organizationData
  const isHK = Boolean(countryCode === 'HK')
  const MaintenanceData = [
    {
      tid: 'weWillBeRightBack',
      type: 'message',
      setBlue: true,
      setBold: true,
      setPadding: true,
      setFont: true,
    },
    {
      tid: 'sorryForInconvenience',
      type: 'message',
      setMargin: true,
    },
    {
      tid: 'ThankYouForUnderstanding',
      type: 'message',
    },
    {
      tid: url,
      type: 'link',
      isLinkAvailable: url,
    },
  ]

  const MaintenanceIcon = [
    {
      tid: `https://www.facebook.com/${facebookHandle}`,
      type: 'Iconlink',
      name: 'FacebookMaintenace',
      isAvailable: facebookHandle,
    },
    {
      tid: `https://www.linkedin.com/company/${linkedinHandle}`,
      type: 'Iconlink',
      name: 'LinkedInMaintenace',
      isAvailable: linkedinHandle,
    },
    {
      tid: `https://twitter.com/${twitterHandle}`,
      type: 'Iconlink',
      name: 'TwitterMaintenace',
      isAvailable: twitterHandle,
    },
    {
      tid: `https://www.youtube.com/channel/${youtubeHandle}`,
      type: 'Iconlink',
      name: 'YouTubeMaintenace',
      isAvailable: youtubeHandle,
    },
  ]
  const getStyledComp = (data) => {
    const {
      tid,
      type,
      setBlue,
      setBold,
      name,
      setMargin,
      setPadding,
      setFont,
      isAvailable,
      isLinkAvailable,
    } = data

    switch (type) {
      case 'message':
        return (
          <StyledMessage
            setBlue={setBlue}
            setBold={setBold}
            setMargin={setMargin}
            setPadding={setPadding}
            setFont={setFont}
          >
            <Text tid={tid} />
          </StyledMessage>
        )
      case 'link':
        return isLinkAvailable ? (
          <StyledLink href={tid} target="_blank">
            {tid}
          </StyledLink>
        ) : null
      case 'Iconlink':
        return isAvailable ? (
          <StyledLink href={tid} target="_blank">
            {getJsx(name)}
          </StyledLink>
        ) : null
      default:
        return null
    }
  }

  return (
    <Container>
      <Center>
        {isHK ? (
          <MaintenanceWrp>
            <Maintenance>
              <MaintenanceImg src="/paymentPageLogo.png" alt="logo" />
            </Maintenance>
          </MaintenanceWrp>
        ) : (
          <TruckLogoMaintenace />
        )}
        {MaintenanceData.map((item) => getStyledComp(item))}
        <StyledFollusUs setBold>
          <Text tid="followUsOn" />
        </StyledFollusUs>
        <IconsContainer>
          {MaintenanceIcon.map((item) => getStyledComp(item))}
        </IconsContainer>
      </Center>
    </Container>
  )
}

function getJsx(name) {
  switch (name) {
    case 'FacebookMaintenace':
      return <FacebookMaintenace />
    case 'YouTubeMaintenace':
      return <YouTubeMaintenace />
    case 'TwitterMaintenace':
      return <TwitterMaintenace />
    case 'LinkedInMaintenace':
      return <LinkedInMaintenace />
    default:
      return null
  }
}
